import { CloudAnimation } from './CloudAnimation';

export enum LayoutAnimationType {
  CLOUD = 'cloud',
}

export const LayoutAnimation = ({ animationType }: { animationType?: LayoutAnimationType }) => {
  if (animationType === LayoutAnimationType.CLOUD) {
    return <CloudAnimation />;
  }
  return null;
};
